import type { SVGProps } from 'react'

export const Discount = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.1017 6.06573C13.1833 6.1474 13.1833 6.27906 13.1017 6.36073C13.02 6.4424 12.8883 6.4424 12.8067 6.36073C12.725 6.27906 12.725 6.1474 12.8067 6.06573C12.8883 5.9849 13.02 5.9849 13.1017 6.06573"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1533 9.145C16.4817 8.81583 16.6667 8.37083 16.6667 7.90583V4.25167C16.6667 3.28417 15.8825 2.5 14.9142 2.5H11.26C10.7958 2.5 10.35 2.685 10.0217 3.01333L3.01334 10.0217C2.32917 10.7058 2.32917 11.815 3.01334 12.4992L6.66751 16.1533C7.35167 16.8375 8.46084 16.8375 9.14501 16.1533"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.968 10.4169C13.0938 10.1616 13.3537 10 13.6382 10C13.9228 10 14.1827 10.1616 14.3085 10.4169L14.8548 11.5243C14.9631 11.745 15.1736 11.8978 15.417 11.9325L16.6405 12.1146C16.9218 12.1558 17.1553 12.3531 17.2429 12.6235C17.3306 12.8939 17.2572 13.1907 17.0537 13.3891L16.1693 14.2515C15.9928 14.4228 15.9126 14.6704 15.9552 14.9127L16.1633 16.1292C16.2118 16.4095 16.0967 16.6929 15.8666 16.8601C15.6365 17.0273 15.3314 17.0492 15.0798 16.9166L13.9874 16.3423C13.7686 16.2255 13.5059 16.2255 13.2871 16.3423L12.1956 16.9166C11.9441 17.0492 11.6389 17.0273 11.4089 16.8601C11.1788 16.6929 11.0637 16.4095 11.1122 16.1292L11.3203 14.9127C11.3624 14.6705 11.2823 14.4231 11.1062 14.2515L10.2258 13.3891C10.0223 13.1908 9.94885 12.8942 10.0363 12.6239C10.1237 12.3535 10.3569 12.1561 10.638 12.1146L11.8605 11.9325C12.1039 11.8978 12.3144 11.745 12.4227 11.5243L12.968 10.4169Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
